import { Helmet } from 'react-helmet-async';

import { paths } from '@farmersdog/constants';
import { Link, ResponsiveText } from '@farmersdog/corgi';
import { GridContainer } from '@farmersdog/corgi-x';

import { Picture } from '../Picture';

import { diggingDogSources } from './assets';
import styles from './NotFound.css';

export function NotFound() {
  return (
    <>
      <Helmet>
        <title>Not Found | The Farmer’s Dog</title>
      </Helmet>
      <section className={styles.section}>
        <GridContainer>
          <div className={styles.row}>
            <Picture sources={diggingDogSources} alt="digging dog" />
          </div>
          <div className={styles.row}>
            <ResponsiveText
              className={styles.heading}
              variant="heading-1"
              color="kale-3"
              as="h1"
            >
              This page can’t be found.
            </ResponsiveText>
            <ResponsiveText
              className={styles.text}
              variant="body-1"
              color="charcoal-3"
              as="p"
            >
              We’ll dig into it, but try going back for now.
            </ResponsiveText>
            <div className={styles.cta}>
              <Link asButton href={paths.PATH_HOME}>
                Back to Homepage
              </Link>
            </div>
          </div>
        </GridContainer>
      </section>
    </>
  );
}
